module.exports = __webpack_public_path__ + "static/media/sort.f7e496a3.png";